import { render } from "./BlogDetailsArea.vue?vue&type=template&id=505e0a12"
import script from "./BlogDetailsArea.vue?vue&type=script&lang=js"
export * from "./BlogDetailsArea.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__